import React from 'react'
import { SpinnerComponent } from './styles'

export interface SpinnerIconLoaderProps {
  iconComponent: React.ReactNode
  size: number
  velocity: number
}

/**
 * This component will render a loader with some random icon component inside to rotate
 * @param {SpinnerIconLoaderProps['iconComponent']} iconComponent - component to render inside the loader
 * @param {SpinnerIconLoaderProps['size']} size - width of loader (width and height)
 * @param {SpinnerIconLoaderProps['velocity']=} velocity - the velocity to rotate the loader
 * @returns {JSX.Element} return the animated loader
 * @example
 * <SpinnerIconLoader iconComponent={<IconComponent name="loaderIcon" />} size={10} velocity={2} />
 */

export const SpinnerIconLoader = ({ iconComponent, velocity, size }: SpinnerIconLoaderProps): JSX.Element => {
  return (
    <>
      <SpinnerComponent data-testid="spinnerComponent" velocity={velocity} size={size}>
        {iconComponent}
      </SpinnerComponent>
    </>
  )
}
